import { ForwardRefExoticComponent, RefAttributes } from "react";
import { ReportFilterKey } from "../model/use-report-filters";
import { RequestsReportTable } from "./requests-report.table";
import { CollectionReportTable } from "./collection-report.table";
import { UniversalReportTable } from "./universal-report.table";
import { SchedulesReportTable } from "./schedules-report.table";
import { NonCollectionReportTable } from "./non-collection-report.table";
import { PhotoCoverageReportTable } from "./photo-coverage-report.table";
import { PickupLocationRegistryReportTable } from "./pickup-location-registry-report.table";
import {
  DriverRegistryReportTable,
  LoaderRegistryReportTable,
} from "./staff-registry-report.table";
import { TruckRegistryReportTable } from "./truck-registry-report.table";
import { CounterpartyReportTable } from "./counterparty-report.table";
import { ReportTableHandle, ReportTableProps } from "./report-table";

/** The report tabs, in the order of the AIS «Раздел 15» they mirror. */
export const REPORT_TABS = [
  // 15.1.1
  {
    id: "requests-table",
    label: "reports.requests",
    Component: RequestsReportTable,
    filters: ["serviceReceiver", "pickupLocation", "containerType"],
  },
  // 15.1.2
  {
    id: "registry-table",
    label: "reports.registry",
    Component: CollectionReportTable,
    filters: ["serviceReceiver", "pickupLocation", "containerType", "driver", "truck"],
  },
  // 15.1.3
  {
    id: "summary-table",
    label: "reports.summary",
    Component: UniversalReportTable,
    filters: ["serviceReceiver", "pickupLocation", "containerType", "truck"],
  },
  // 15.1.4
  {
    id: "schedules-table",
    label: "reports.schedules",
    Component: SchedulesReportTable,
    filters: ["jobType", "containerType", "jobCategory"],
  },
  // 15.1.7
  {
    id: "non-collection-table",
    label: "reports.nonCollection",
    Component: NonCollectionReportTable,
    filters: ["jobStatus", "driver", "truck"],
  },
  // 15.2.1
  {
    id: "photo-table",
    label: "reports.photoCoverage",
    Component: PhotoCoverageReportTable,
    filters: [],
  },
  // 15.3.1
  {
    id: "pickup-location-registry-table",
    label: "reports.siteRegistry",
    Component: PickupLocationRegistryReportTable,
    filters: ["serviceReceiver", "containerType"],
  },
  // 15.3.2
  {
    id: "driver-registry-table",
    label: "reports.driverRegistry",
    Component: DriverRegistryReportTable,
    filters: [],
  },
  // 15.3.3
  {
    id: "loader-registry-table",
    label: "reports.loaderRegistry",
    Component: LoaderRegistryReportTable,
    filters: [],
  },
  // 15.3.4
  {
    id: "truck-registry-table",
    label: "reports.truckRegistry",
    Component: TruckRegistryReportTable,
    filters: [],
  },
  // No AIS item number.
  {
    id: "counterparty-registry-table",
    label: "reports.counterpartyRegistry",
    Component: CounterpartyReportTable,
    filters: ["counterparties", "customerTypes", "jobTypes", "containerTypes", "counterpartyView"],
  },
] as const satisfies readonly {
  id: string;
  label: string;
  Component: ForwardRefExoticComponent<ReportTableProps & RefAttributes<ReportTableHandle>>;
  /** The filters the page header's filter sheet offers for this report. */
  filters: readonly ReportFilterKey[];
}[];

export type ReportTabId = (typeof REPORT_TABS)[number]["id"];

export const DEFAULT_REPORT_TAB: ReportTabId = "requests-table";

export const isReportTabId = (value: string | null): value is ReportTabId =>
  REPORT_TABS.some((tab) => tab.id === value);

export const reportTab = (id: string) => REPORT_TABS.find((tab) => tab.id === id) ?? REPORT_TABS[0];
